import type { DeploymentAreaDerivedPopulationMetrics } from "@situate/contracts";

export interface PopulationMetricInputs {
  totalPopulation: number | null | undefined;
  departuresLoungePopulation: number | null | undefined;
}

export function calculateDerivedPopulation(
  metrics: DeploymentAreaDerivedPopulationMetrics | null | undefined,
  inputs: PopulationMetricInputs
): number | null {
  const config = metrics?.duty_free_population;
  if (
    config?.method !== "subtract" ||
    config.minuend !== "total_population" ||
    config.subtrahend !== "departures_lounge_population" ||
    inputs.totalPopulation == null ||
    inputs.departuresLoungePopulation == null
  ) {
    return null;
  }

  return Math.max(0, inputs.totalPopulation - inputs.departuresLoungePopulation);
}
